module.exports = __webpack_public_path__ + "static/media/bars-solid.ec04feaf.svg";